//西班牙
export default {
    common: {
        notshow: 'No se presente hoy',
        unit: 'USDT',
        day: 'Día',
        week: 'Semana',
        save: 'Guardar',
        submit: 'Enviar',
        confirmtitle: 'Confirmar operación',
        confirm: 'Confirmar',
        reset: 'Restablecer',
        refresh: 'Actualizar',
        copy: 'Copiar',
        copysuccessful: 'Copiado exitosamente',
        modify: 'Modificar',
        binding: 'Vincular',
        finished: 'Completado',
        canceled: 'Cancelado',
        cancel: 'Cancelar',
        all: 'Todo',
        back: 'Volver',
        loading: 'Cargando...',
        nomore: 'No hay más registros',
        errortxt: 'Error al cargar',
        loosing: 'Suelte para actualizar...',
        pulling: 'Tire para actualizar...',
        nodata: 'Sin registros',
        buy: 'Comprar',
        buyup: 'Comprar al alza',
        buydown: 'Comprar a la baja',
        sell: 'Vender',
        forserver: 'Contactar servicio al cliente',
        total: 'Total',
        status1: 'Pendiente de revisión',
        status2: 'Completado',
        status3: 'Rechazado',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Transferencia bancaria'
    },
    footer: {
        home: 'Inicio',
        market: 'Mercado',
        exchange: 'Intercambio',
        options: 'Opciones',
        assets: 'Activos',
        change: 'Transferencia',
        recharge: 'Depósito',
        withdrawal: 'Retiro'
    },
    home: {
        menu1: 'Trading de opciones',
        menu1desc: 'Soporta BTC/USDT etc',
        menu2: 'Depósito rápido',
        menu3: 'Retiro',
        menu4: 'Soporte en línea',
        menu5: 'Intercambio rápido',
        menu6: 'Préstamos',
        menu7: 'Mining Staking',
        menu8: 'Garantía',
        menu9: 'Transferencia de cuenta',
        ranktitle: 'Lista de subidas',
        name: 'Nombre',
        price: 'Último precio',
        risefall: '% Cambio'
    },
    register: {
        register: 'Registrarse',
        login: 'Iniciar sesión',
        email: 'Correo',
        phone: 'Teléfono',
        accountplaceholder: 'Ingrese la cuenta',
        emailplaceholder: 'Ingrese el correo',
        phoneplaceholder: 'Ingrese el número de teléfono',
        pwdplaceholder: 'Ingrese la contraseña',
        pwdplaceholder1: 'La contraseña debe tener 6-20 caracteres',
        agepwdplaceholder: 'Confirme la contraseña',
        agepwdplaceholder1: 'Las contraseñas no coinciden',
        invitecodeplaceholder: 'Ingrese el código de invitación',
        remember: 'Recordar contraseña',
        fotget: 'Olvidé la contraseña'
    },
    market: {
        title: 'Mercado',
        all: 'Todo'
    },
    member: {
        reputation: 'Puntuación de crédito',
        identity_authentication: 'Verificación de identidad',
        under_review: 'En revisión',
        certified: 'Verificado',
        awaiting_certification: 'Pendiente de verificación',
        binding_withdrawal_address: 'Vincular dirección de retiro',
        currently_selected_currency: 'Moneda actual',
        withdrawal_address: 'Dirección de retiro',
        sharing_link: 'Mi enlace de compartir',
        my_promotion_code: 'Mi código de promoción',
        promotion_code: 'Código de promoción',
        system_message: 'Mensaje del sistema',
        night_mode: 'Modo nocturno',
        security_center: 'Centro de seguridad',
        seted: 'Configurado',
        noset: 'No configurado',
        login_password: 'Contraseña de inicio de sesión',
        transaction_password: 'Contraseña de transacción',
        app_download: 'Descargar app',
        log_out: 'Cerrar sesión',
        aboutus: 'Introducción al sitio web'
    },
    identity: {
        title: 'Verificación de identidad',
        name: 'Nombre',
        nameplaceholder: 'Ingrese nombre real',
        uploader: 'Subir foto de ID',
        tip1: 'Subir frente del documento de identidad',
        tip2: 'Subir reverso del documento de identidad'
    },
    address: {
        title: 'Vincular dirección de retiro',
        bType: 'Moneda actual',
        address: 'Dirección de retiro',
        addressplaceholder: 'Ingrese dirección de retiro'
    },
    security: {
        title: 'Centro de seguridad',
        modifypwd: 'Contraseña de inicio de sesión',
        resetlegalpwd: 'Contraseña de transacción',
        loginpwd: 'Nueva contraseña de inicio de sesión',
        pwdage: 'Confirmar contraseña',
        loginpwdplaceholder: 'Ingrese contraseña de inicio de sesión actual',
        loginnewpwdplaceholder: 'Ingrese nueva contraseña de inicio de sesión',
        moneypwd: 'Ingrese contraseña de transacción',
        pwdageplaceholder: 'Confirme nuevamente la contraseña'
    },
    trade: {
        title: 'Trading de intercambio',
        price: 'Precio',
        num: 'Cantidad',
        entrust: 'Órdenes pendientes',
        clinch: 'Transacciones completadas',
        used: 'Disponible',
        buyed: 'Puede comprar',
        amount: 'Monto de trading',
        limitprice: 'Precio límite',
        marketprice: 'Precio de mercado',
        forprice: 'Operar al mejor precio actual',
        errorMoney: 'Saldo insuficiente',
        priceerror: 'Ingrese precio de orden',
        numerror: 'Ingrese cantidad de orden',
        moneyerror: 'Ingrese valor de orden'
    },
    assets: {
        allconvert: 'Valor total de activos',
        usenum: 'Disponible',
        freeze: 'Congelado',
        convert: 'Convertir',
        tab1: 'Activos',
        tab11: 'Valor total de activos',
        tab12: 'Valor de opciones',
        tab13: 'Valor de fondos',
        tab14: 'Valor cuantitativo',
        tab2: 'Opciones',
        tab21: 'Cuenta de opciones',
        tab3: 'Fondos',
        tab31: 'Cuenta de fondos',
        tab4: 'Cuant',
        tab41: 'Cuenta cuant',
        tbhead1: 'Registros financieros',
        tbhead2: 'Registros de retiro',
        tbhead3: 'Registros de depósito',
        tbhead4: 'Registros de transferencia',
        rcdnum: 'Monto',
        rcd: 'Registro',
        rcdtime: 'Hora',
        rcdstatus: 'Estado',
        rcddesc: 'Notas',
        rcdaddress: 'Dirección de depósito'
    },
    change: {
        title: 'Transferencia',
        from: 'De {name}',
        to: 'A {name}',
        frmtitle: 'Monto de transferencia',
        inputplaceholder: 'Ingrese monto de transferencia',
        btntxt: 'Transferir'
    },
    recharge: {
        title: 'Depósito',
        bType: 'Moneda actual',
        address: 'Dirección de depósito',
        token: 'Comprobante de pago',
        tokenplaceholder: 'Subir comprobante de pago',
        num: 'Monto de depósito',
        numplaceholder: 'Ingrese monto',
        btn: 'Enviar para revisión',
        bankname: 'Nombre del banco',
        bankno: 'Número de banco',
        accountname: 'Nombre de cuenta',
        bankaddress: 'Dirección del banco',
        bankcode: 'Código de transferencia',
        companyaddress: 'Dirección de la empresa'
    },
    withdrawal: {
        title: 'Retiro',
        frmtitle1: 'Monto',
        frmplaceholder1: 'Monto de retiro entre {min} - {max}',
        frmtitle2: 'Contraseña de transacción',
        frmplaceholder2: 'Ingrese contraseña de transacción',
        getnum: 'Monto a recibir',
        fee: 'Comisión',
        btn: 'Retirar'
    },
    exchangeb: {
        title: 'Intercambio',
        account: 'Cuenta',
        btn: 'Intercambiar',
        numerror: 'Ingrese monto de intercambio'
    },
    option: {
        title: 'Opciones',
        typetitle: 'Contrato secundario',
        listtitle: 'Posiciones',
        kline: 'Gráfico K',
        high: 'Alto',
        low: 'Bajo',
        nums: 'Vol 24H',
        time: 'Tiempo',
        transaction: 'Modo de trading',
        quantity: 'Tamaño de posición',
        quantityerror: 'Ingrese tamaño de posición',
        times: 'Hora de apertura',
        times1: 'Hora de liquidación',
        account: 'Saldo de cuenta',
        buyup: 'Comprar al alza',
        buydown: 'Comprar a la baja',
        tab1: 'Lista de posiciones',
        tab2: 'Historial de órdenes',
        num: 'Monto',
        price1: 'Precio de compra',
        price2: 'Precio de liquidación',
        profitandloss: 'G/P est.',
        profitandloss1: 'G/P',
        countdown: 'Cuenta regresiva',
        waitfinish: 'Esperando liquidación',
        finishing: 'Liquidando...',
        finished: 'Liquidado',
        order_price: 'Precio actual',
        order_cycle: 'Período',
        order_type: 'Tipo',
        order_money: 'Monto',
        order_time: 'Apertura',
        order_get: 'Ganancia',
        order_btn: 'Continuar trading'
    },
    tradelst: {
        title: 'Mis órdenes',
        tab1: 'Órdenes',
        tab2: 'Completadas',
        tab3: 'Canceladas',
        usdtnum: ''
    },
    loans: {
         repayment: 'Reembolso',
        title: 'Préstamos',
        order_tab: 'Órdenes de préstamo',
        pro_tab: 'Productos de préstamo',
        Institution: 'Institución de préstamo',
        Amount: 'Monto',
        DailyInterest: 'Tasa de interés diaria',
        RepaymentPeriod: 'Período de reembolso',
        Application: 'Solicitar préstamo',
        orderno: 'N° de orden',
        AllInterest: 'Interés total',
        RepaymentDate: 'Fecha de reembolso',
        RepaymentMethod: 'Método de reembolso',
        Onetime: 'Una vez',
        Expected_loan_amount: 'Monto de préstamo esperado',
        Expected_loan_amounterror: 'Monto de préstamo entre {min} - {max}',
        imgplaceholdr: 'Préstamo de crédito (Asegúrese que las imágenes sean claras)',
        icon1: 'Subir frente del documento de identidad',
        icon2: 'Subir reverso del documento de identidad',
        icon3: 'Subir documento de identidad sostenido en mano',
        status1: 'Solicitando',
        status2: 'Aprobado',
        status3: 'Rechazado'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Órdenes de minería',
        pro_tab: 'Mercado de minería',
        locknum: 'Monto mín de staking',
        getforday: 'Rendimiento/Días',
        days: 'Días',
        estimation: 'Ganancias est.',
        real: 'Ganado',
        balance: 'Saldo de billetera',
        nums: 'Monto de staking',
        tolockming: 'Hacer staking',
        stime: 'Hora de inicio',
        etime: 'Hora de fin'
    },
    transfer: {
        title: 'Transferencia de cuenta',
        searchtxt: 'Ingrese cuenta del destinatario',
        ReceivingAccount: 'Info cuenta destinatario',
        toaccount: 'Cuenta',
        confirmtxt: 'Haga clic para confirmar cuenta destinatario',
        confirmedtxt: 'Cuenta destinatario confirmada',
        numtxt: 'Monto de transferencia',
        numerror: 'Ingrese monto de transferencia',
        fee: 'Sin comisión para transferencias internas',
        ArrivalTime: 'Hora de llegada',
        Immediately: 'Inmediato',
        realnum: 'Monto real de llegada',
        btn: 'Confirmar transferencia',
        transfering: 'Transfiriendo',
        orderNo: 'N° de orden',
        stime: 'Hora de transferencia',
        etime: 'Hora de llegada',
        receiving: 'Cuenta destinatario',
        type: 'Moneda',
        num: 'Monto de transferencia',
        arrivalnum: 'Monto recibido'
    },
    staking: {
        title: 'Staking',
        record: 'Registros',
        getforyear: 'Rendimiento anual est.',
        time: 'Período de inversión',
        snum: 'Inversión mín',
        snumerror: 'Ingrese monto de inversión',
        snumerror1: 'Inversión mín no menor a {num}',
        join: 'Participar ahora',
        opentime: 'Hora de apertura',
        money: 'Monto de inversión',
        days: 'Período',
        recordget: 'Rendimiento anual',
        gets: 'Ganancias',
        stime: 'Fecha de inicio',
        etiem: 'Fecha de fin',
        redeemStaking: 'Canjear',
        status0: 'Staking',
        status1: 'Orden completada',
        status2: 'Orden canjeada'
    },
    bank:{
        title: 'Vincular Tarjeta Bancaria',  // 标准化欧盟支付服务命名‌:ml-citation{ref="5" data="citationList"}
        bankName: 'Entidad Bancaria',  // 符合西班牙银行注册名称规范‌:ml-citation{ref="1" data="citationList"}
        bankNameError: 'Introduzca el nombre del banco',  // 强制输入提示规范‌:ml-citation{ref="1,5" data="citationList"}
        usrName: 'Titular de la Tarjeta',  // 根据Ley 16/2009反洗钱要求全名显示‌:ml-citation{ref="5" data="citationList"}
        usrNameError: 'Nombre del titular requerido',  // 实名验证要求‌:ml-citation{ref="1,5" data="citationList"}
        cardCode: 'Número de Tarjeta',  // ISO/IEC 7812格式规范‌:ml-citation{ref="5,6" data="citationList"}
        cardCodeError: 'Número de tarjeta obligatorio',  // 支付系统强制验证‌:ml-citation{ref="1" data="citationList"}
        towallet: 'Retirar a Monedero Digital',  // 西班牙央行加密资产服务注册要求‌:ml-citation{ref="5" data="citationList"}
        tobank: 'Retirar a Cuenta Bancaria',  // SEPA信用转账规范‌:ml-citation{ref="5" data="citationList"}
        sendcode: 'Enviar Código de Verificación',  // PSD2 SCA双重认证要求‌:ml-citation{ref="5" data="citationList"}
        sended: 'Reenviar en {num} segundos',  // 符合UNE-EN 28601时间格式‌:ml-citation{ref="5" data="citationList"}
        verify_code: 'Código de verificación por email'  // 欧盟电子身份验证标准‌:ml-citation{ref="5" data="citationList"}
      }
      
}
